import React, { memo } from "react";
import "./styles.scss";
import Button from "react-bootstrap/Button";

const FooterButtons = ({
  canelHandler = () => {},
  saveHandler = () => {},
  isLoading,
  disabled = false,
}) => {
  return (
    <>
      <div className="d-flex align-items-center justify-content-between">
        <Button
          style={{
            height: "56px",
            width: "124px",
            borderRadius: "5px",
            backgroundColor: "white",
            borderColor: "gray",
            color: "#6E7485",
            fontFamily: "inherit",
            fontSize: "18px",
            fontWeight: "600",
          }}
          onClick={canelHandler}
          variant="primary"
        >
          Cancel
        </Button>
        {!disabled && (
          <Button
            style={{
              height: "56px",
              width: "167px",
              borderRadius: "5px",
              backgroundColor: "#564FFD",
              color: "white",
              fontFamily: "inherit",
              fontSize: "18px",
              fontWeight: "600",
            }}
            onClick={saveHandler}
            variant="primary"
            disabled={isLoading || disabled}
          >
            Save & Next
          </Button>
        )}
      </div>
    </>
  );
};

export default memo(FooterButtons);
